<div class="container u-mt60">
  <div class="row">
    <div class="col-12">
      <app-breadcrum [breadcrums]="breadcrums"></app-breadcrum>
    </div>
    <div class="col-md-8">
      <h1 class="u-mb60 txt txt--title">
        {{title}}
      </h1>
    </div>
  </div>
</div>
<div class="bg--lightgrey u-pt50 u-pb70">
  <div class="container">
    <div class="row">
      <div class="col-md-8 offset-md-2">
        <div class="u-center">
          <div *ngIf="!shouldShowFlow && variant === 'success'" class="icon icon--success u-mb30"></div>
          <img *ngIf="variant === 'failure'" class="icon u-mb30" src="assets/img/icon-bad.png" alt="">
          <h2 class="u-mb30 txt txt--subtitle">
            {{subtitle}}
          </h2>
        </div>
      </div>
      <div class="flow-display-correction">
        <app-flow-states
          *ngIf="shouldShowFlow && variant === 'success'"
          [id]="id"
          class="correct-centering"
        >
        </app-flow-states>
      </div>
      <div class="col-md-8 offset-md-2">
        <div class="u-center">

          <div
            *ngIf="messageBold || message"
            class="box box--white u-mb20 u-mt20"
            [ngClass]="{
              'backgroundGrey': !classBackgroundWhiteActionButton,
              'u-mb20': actionButtonDescription,
              'u-mb40': !actionButtonDescription
            }"
          >
            <div class="row">
              <div class="col-md-8 offset-md-2">
                <p class="txt u-mb0" *ngIf="messageBold"  >
                  <strong>
                    {{messageBold}}
                  </strong>
                </p>
                <p class="txt txt-paragraph u-mb0">
                  {{message}}
                </p>
              </div>
            </div>
          </div>
          <div *ngIf="actionButtonDescription" class="u-mb20">
            {{actionButtonDescription}}
          </div>
          <div class="" *ngIf="actionButtonPath || actionButtonText">
            <a [routerLink]="actionButtonPath" type="button" class="btn btn--primary" *ngIf="showButtonAction">{{actionButtonText}}</a>
          </div>
          <div class="u-mb50 u-mt5">
            <a [routerLink]="secondaryButtonPath" class="btn btn--link btn--link--secondary">{{secondaryButtonText}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
